import React, { useState } from 'react';
import moment from 'moment';

import { CompletionButton, TaskTile, Text } from 'shell/components';

const today = moment().hour(0).minute(0).second(0).millisecond(0);
const yesterday = moment(today).subtract(1, 'day');
const tomorrow = moment(today).add(1, 'day');

const assignees = {
    1: 'Georgina Watson',
};

const TaskTileDemo = () => {
    const [tasks, setTasks] = useState({
        1: {
            id: '1',
            title: 'Task 1',
            workload: 'low',
            end_on: yesterday.valueOf(),
            status: 'toDo',
            assignee_account_id: '1',
        },
        2: { id: '2', title: 'Task 2', workload: 'medium', end_on: today.valueOf(), status: 'toDo' },
        3: { id: '3', title: 'Task 3', workload: 'high', end_on: tomorrow.valueOf(), status: 'completed' },
    });

    return (
        <>
            <Text variant={'sh1'}>TaskTile</Text>
            {Object.values(tasks).map((task) => (
                <TaskTile
                    key={task.id}
                    endComponent={
                        <CompletionButton
                            checked={task.status === 'completed'}
                            onClick={(e) => {
                                e.stopPropagation();
                                setTasks((current) => ({
                                    ...current,
                                    [task.id]: {
                                        ...current[task.id],
                                        status: current[task.id].status === 'toDo' ? 'completed' : 'toDo',
                                    },
                                }));
                            }}
                        />
                    }
                    getNameById={(id) => assignees[id]}
                    task={task}
                    onClick={console.log}
                />
            ))}
        </>
    );
};

export default TaskTileDemo;
